import { Bookmark } from '../../constants/apis';
import type { BookmarksPagination } from '../../types/profile';
import { ApiManager } from '../axios-config';
import type { BookmarkAddFormType, BookmarkChip, BookmarkEditFormType } from './../../types/articles/bookmark';

export const addBookmark = async (data: BookmarkAddFormType, token: string) => {
  return await ApiManager.post(`${Bookmark}`, data, { headers: { Authorization: `Bearer ${token}` } });
};

export const editBookmark = async (data: BookmarkEditFormType, token: string) => {
  return await ApiManager.put(`${Bookmark}/${data.id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const removeBookmark = async (id: string, token: string) => {
  return await ApiManager.delete(`${Bookmark}/${id}`, { headers: { Authorization: `Bearer ${token}` } });
};

export const getBookmarkList = async (userId: string, token: string) => {
  return await ApiManager.get<BookmarkChip[]>(`${Bookmark}?UserId=${userId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const bookmarkArticle = async (
  { listIds, articleId }: { listIds: string[]; articleId: string },
  token: string,
) => {
  return await ApiManager.put(
    `${Bookmark}/article`,
    {
      listIds,
      articleId,
    },
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const getArticleBookmarkStatus = async (articleId: string, token: string) => {
  return await ApiManager.get<string[]>(`${Bookmark}/status/${articleId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getBookmarkArticles = async ({
  id,
  token,
  pageSize = 10,
  pageNumber = 1,
}: {
  id: string;
  token: string;
  pageNumber?: number;
  pageSize?: number;
}) => {
  const bookmarkArticlesUrl = new URL(`${Bookmark}/${id}`);
  const params = new URLSearchParams({
    id,
    PageNumber: `${pageNumber}`,
    PageSize: `${pageSize}`,
  });

  bookmarkArticlesUrl.search = params.toString();

  return await ApiManager.get<BookmarksPagination>(bookmarkArticlesUrl.toString(), {
    headers: { Authorization: `Bearer ${token}` },
  });
};
